import fineTunePostsView from './fineTunePostsView.html';
import _ from 'lodash';
import './fineTunePostsStyles.css';
import { DateRangeCalculator } from 'components/sharpr/date/dateRangeCalculator/DateRangeCalculator';
import { ensure } from 'components/sharpr/ensure/ensure.js';

export default function fineTunePostsComponent() {
	return {
		bindings: {
			hubs: '<?',
			search: '=',
			excludeCopied: '=?',
			collapseWhen: '=?',
			collapseShow: '@?',
			posts: '=?',
			postCount: '=?',
			favoritesPosts: '=?',
			searchStatus: '=?',
			countOnly: '=?',
			excludeRestrictedFromShareViaEmailBrief: '<?',
			infiniteScroll: '<?',
			readWriteUrl: '<?',
			showTermInput: '<?',
			showRecentSearches: '<?',
			showSavedSearches: '<?',
			enableFavoritesSearch: '<?',
			respectPins: '<?',
			immutableFields: '<?',
			preserveTime: '<?',
			enableSearch: '<?',
			columnBlacklist: '@?',
			maxCheckboxes: '@?',
			filtersUpdatedCallback: '<?',
			hasSearchOccurred: '=?',
		},
		controllerAs: 'vm',
		controller: fineTunePostsComponentCtrl,
		template: fineTunePostsView,
	};
}

class fineTunePostsComponentCtrl {
	constructor(
		$element,
		$scope,
		$timeout,
		Cfg,
		Api,
		FineTunePosts,
		ScrollManager,
		EventTracker,
		UrlData,
		Identity,
		Taxonomy,
		AutoArchive
	) {
		'ngInject';
		// save injections
		this.$element = $element;
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.Cfg = Cfg;
		this.Api = Api;
		this.FineTunePosts = FineTunePosts;
		this.ScrollManager = ScrollManager;
		this.EventTracker = EventTracker;
		this.UrlData = UrlData;
		this.Identity = Identity;
		this.Taxonomy = Taxonomy;
		this.AutoArchive = AutoArchive;
	}

	$onInit() {
		// setup options
		this.hasApprovalWorkflow = this.Cfg.readAsBool('Features.post_approval');
		this.postArchiveEnabled =
			this.Cfg.readAsBool('PostArchive.enable_archive') || this.Cfg.readAsBool('PostArchive.enable_destroy');
		this.showArchiveOptions = !(
			this.Cfg.readAsBool('PostArchive.enable_destroy') && !this.Cfg.readAsBool('PostArchive.enable_archive')
		);
		this.showSearchDomains = this.Cfg.readAsBool('Search.show_websites');
		this.showSearchPublishers = this.Cfg.readAsBool('Search.show_publishers');
		this.showSearchOptions = this.Cfg.readAsBool('Search.show_options');
		this.blacklistColumns = this.columnBlacklist || '';
		this.blacklistColumns = this.blacklistColumns.split(',');
		this.showMultiHub = !this.isBlacklistColumn('multihub') && this.Cfg.readAsBool('Search.show_multihub');
		this.defaultMultiHub = this.Cfg.readAsBool('Search.default_multihub');
		this.showSearchType = false;
		this.searchStatus = 'none';
		this.isCollapsible = this.$element[0].hasAttribute('collapse-when');
		if (!this.maxCheckboxes) {
			this.maxCheckboxes = window.isMobile ? Infinity : 8;
		} else {
			this.maxCheckboxes = parseInt(this.maxCheckboxes);
		}
		this.postsPerRequest = window.isMobile ? 12 : 25;
		this.isMobile = window.isMobile;
		window.warnSharprAboutMemory = _.throttle(() => this._reduceMemory(), 500, {
			leading: true,
			trailing: false,
		});

		this.FineTunePosts.hubs = this.hubs;
		if (this.preserveTime) {
			this.FineTunePosts.setPreserveTime(true);
		}
		// setup search
		this.search = _.extend(this._getDefaultSearch(), this.search);
		this.search.multiHubEnabled = this.showMultiHub;

		if (this.readWriteUrl) {
			_.extend(this.search, this.UrlData.get('finetune') || {});
			this.UrlData.on(
				'finetune',
				newVal => {
					if (newVal && !_.isEmpty(newVal)) {
						this.search = _.extend(this._getDefaultSearch(), newVal);
						this._ensureValidSearch();
					} else {
						this.search = this._getDefaultSearch();
					}
					this.$timeout(() => {});
				},
				this.$scope
			);
			this.$scope.$on('$destroy', () => {
				this.UrlData.set('finetune', undefined);
			});
		}
		this._ensureValidSearch();
		// setup watches
		setTimeout(() => {
			// use timeout to avoid re-fetching data immediately after rendering
			this.$scope.$watch(
				'vm.search',
				_.throttle(this.updateSearch.bind(this), 500, { leading: false, trailing: true }),
				true
			);
		}, 0);
		this.$scope.$watch('vm.collapseWhen', this.handleCollapseToggle.bind(this));
		this.$scope.$watch('vm.infiniteScroll', this.handleInfiniteScrollChange.bind(this));
		this.$scope.$watch('vm.hubs', _.throttle(this.updateHubs.bind(this), 500, { leading: false, trailing: true }), true);
		// respond to pins
		this.$scope.$on('post-pin', this._handlePostPin.bind(this));
		this.$scope.$on('post-unpin', this._handlePostUnpin.bind(this));
		// setup other things
		this.setupDatePicker();
		this.setupArchivePicker();
		if (this.infiniteScroll > 0) {
			this.setupInfiniteScroll();
		}
		this.canStandardIntel = this.Identity.can('standard_intel');
		this.Taxonomy.getClientUserCount().then(count => {
			this.hasClientUsers = count > 0;
		});
		this.loadPosts();
		this.filterCount = 0;
		this.filterChangeCallback = this.filterChangeCallback.bind(this);
	}

	$onDestroy() {
		window.warnSharprAboutMemory = () => {};
		if (this.scrollHandler) {
			this.ScrollManager.unregister(window, this.scrollHandler);
		}
	}

	updateHubs(newVal, oldVal) {
		if (!_.isArray(newVal) || _.isEqual(newVal, oldVal)) {
			// console.log('updateHubs: same', newVal, oldVal);
			// hubs is not an array or is the same as before
			return;
		}
		// console.log('updateHubs: different', newVal, oldVal);
		this.loadCheckboxDataIfHubs();
		this.loadPosts();
	}

	updateSearch(newVal, oldVal) {
		this._updateFineTunerArchiveSearch();
		if (!_.isObject(newVal) || _.isEqual(newVal, oldVal)) {
			// search is not an object or is the same as before
			return;
		}
		if (newVal.mode != oldVal.mode && newVal.mode == 'mostRecent') {
			// this will reset all values to default, but will leave anything sent from
			/// a parent component. don't allow it to get to loadPosts because changing
			/// this.search here calls updateSearch() again anyways.
			this.search = this._getDefaultSearch();
		}
		// clear out any existing filtering when the hubs are changed (the new hub list may not have the old tags, categories, etc.)
		if (newVal.multihub !== oldVal.multihub) {
			if (ensure.array(newVal.multihub).length > 0) {
				['categories', 'classifications', 'domains', 'publishers', 'tags'].forEach(item => {
					this.search[item].length = 0;
				});
			} else {
				// if hubs were added or removed, we need to get categories, tags, and classifications for the new list of hubs
				this.loadCheckboxData();
			}
		}
		this.loadPosts();
	}

	resetDateRange() {
		this.search.dateStart = undefined;
		this.search.dateEnd = undefined;
	}

	updateArchiveSearch() {
		//this would be used when a user wants to remove archive filtering
		if (this.tempArchiveAction === '') {
			this._resetArchiveSearch();
			return;
		}
		//We only want to search if both action and preset are set
		if (this.tempArchiveAction !== '' && this.tempArchiveDatePreset !== '') {
			this.search.archiveDatePreset = this.tempArchiveDatePreset;
			this.search.archiveAction = this.tempArchiveAction;
		}
	}

	_updateFineTunerArchiveSearch() {
		if (this.search.archiveAction === undefined) {
			this.tempArchiveAction = '';
			this.tempArchiveDatePreset = '';
		} else {
			this.tempArchiveAction = this.search.archiveAction;
			this.tempArchiveDatePreset = this.search.archiveDatePreset;
		}
		if (this.tempArchiveAction !== '') {
			this.showArchiveFilters = true;
		}
	}

	_reduceMemory() {
		console.log('Memory warning received');
		const details = {
			num_posts: this.posts.length,
			scroll_top: this.ScrollManager.getPosition(window).scrollTop,
		};
		this.EventTracker.save('ios_low_memory', details);
		console.log('Sending memory info event:' + JSON.stringify(details));
	}

	setupDatePicker() {
		this.datePresetNames = DateRangeCalculator.getPresetNames();
		this.dateRangePickerIsOpen = !this.search.dateStart || !this.search.dateEnd;
	}

	setupArchivePicker() {
		this.archiveActions = [{ id: '', name: 'Select type...' }];
		//break out options for archive and destroy preferences
		if (this.Cfg.readAsBool('PostArchive.enable_archive')) {
			this.archiveActions = this.archiveActions.concat([
				{ id: 'active_and_archived', name: 'Active, or archived in last' },
				{ id: 'archive past', name: 'Archived in last' },
				{ id: 'archive future', name: 'Will archive in next' },
			]);
		}
		if (this.Cfg.readAsBool('PostArchive.enable_destroy')) {
			this.archiveActions.push({ id: 'destroy', name: 'Will destroy in next' });
		}
		if (this.Cfg.readAsBool('PostArchive.enable_archive') && this.Cfg.readAsBool('PostArchive.enable_destroy')) {
			this.archiveActions.push({ id: 'both', name: 'Will archive or destroy in next' });
		}

		this.archivePresets = this.AutoArchive.getArchivePresetFineTunerDropdown();
	}

	setupInfiniteScroll() {
		this.scrollHandler = evt => {
			if (isNaN(evt.ratioBottom) || evt.ratioBottom > this.infiniteScroll || this.searchStatus != 'loaded') {
				return;
			}
			this.searchStatus = 'loading';
			this.FineTunePosts.fetchNextPage().then(data => {
				if (!_.isArray(data)) {
					return;
				}
				const existingIds = _.map(this.posts, 'id');
				data.forEach(post => {
					if (existingIds.indexOf(post.id) == -1) {
						// only add if post is not a duplicate
						this.posts.push(post);
					}
				});
				if (this.FineTunePosts.isLastPage) {
					this.searchStatus = 'no_more_posts';
				} else if (data.length === 0) {
					this.searchStatus = 'none_found';
				} else {
					this.searchStatus = 'loaded';
					this._checkForWhitespace();
				}
			});
		};
		this.ScrollManager.register(window, this.scrollHandler);
	}

	_getDefaultSearch() {
		return {
			term: '',
			tags: [],
			categories: [],
			publishers: [],
			domains: [],
			archiveAction: undefined,
			archiveDatePreset: undefined,
			datePreset: 'all',
			dateStart: undefined,
			dateEnd: undefined,
			clientIntel: false,
			wasEmailed: undefined,
			inStory: undefined,
			untagged: undefined,
			approvalStatus: '',
			classifications: [],
			taxonomies: {},
			termBehavior: localStorage.getItem('Search.term_behavior') || this.Cfg.read('Search.term_behavior') || 'narrow',
			orderBy: window.sessionStorage.getItem('Search.default_sort') || this.Cfg.read('Search.default_sort') || 'score',
			limit: this.postsPerRequest,
			multiHubEnabled: this.showMultiHub,
			multihub: this.defaultMultiHub ? 'account' : '',
			myFavorites: false,
		};
	}

	_ensureValidSearch() {
		this.search = ensure.object(this.search);
		// if these are invalid, clicking a checkbox will have no effect
		this.search.tags = ensure.array(this.search.tags);
		this.search.categories = ensure.array(this.search.categories);
		this.search.classifications = ensure.array(this.search.classifications);
		this.search.publishers = ensure.array(this.search.publishers);
		this.search.domains = ensure.array(this.search.domains);
		this.search.datePreset = this.search.datePreset || 'all';
		this.search.multihub = ensure.string(this.search.multihub);
	}

	_getFiltersUsed() {
		const defSearch = this._getDefaultSearch();
		const filters = {};
		// return only filters that are different than default filters
		_.forOwn(this.search, (value, field) => {
			if (!_.isEqual(defSearch[field], value)) {
				filters[field] = value;
			}
		});
		return filters;
	}

	_prependCustomLinks(data) {
		const customLinks = ensure.array(this.Identity.user().custom_links);
		const customPosts = customLinks.map(customLink => {
			return {
				headline: customLink.text,
				source_link: customLink.link,
				image: {
					url: customLink.img,
					height: customLink.img_height,
					width: customLink.img_width,
				},
				read_more_text: customLink.read_more_text,
			};
		});
		data = customPosts.concat(data);
		return data;
	}

	loadPosts() {
		const filtersUsed = this._getFiltersUsed();
		if (this.readWriteUrl) {
			this.UrlData.set('finetune', filtersUsed);
		}
		if (this.lastSearchTerm != this.search.term) {
			this.lastSearchTerm = this.search.term;
		}
		if (this.enableSearch === false) {
			return null;
		}
		//do this because they could pass in 0
		if (this.hasSearchOccurred !== undefined || this.hasSearchOccurred !== null) {
			this.hasSearchOccurred += 1;
		}
		this.searchStatus = 'loading';
		if (this.countOnly) {
			const search = _.extend({}, this.search);
			search.respectPins = false;
			this.FineTunePosts.fetch(search, {
				countOnly: 1,
				excludeCopied: this.excludeCopied ? 1 : 0,
			}).then(data => {
				this.postCount = ensure.object(data).count || 0;
				this.searchStatus = 'loaded';
			});
		} else {
			if (this.posts) {
				this.posts.length = 0;
			}
			const search = _.extend({}, this.search);
			search.respectPins = this.respectPins;
			this.FineTunePosts.fetch(search, {
				countOnly: 0,
				excludeCopied: this.excludeCopied ? 1 : 0,
				excludeRestrictedFromShareViaEmailBrief: this.excludeRestrictedFromShareViaEmailBrief ? 1 : 0,
			}).then(data => {
				if (_.values(filtersUsed).filter(Boolean).length === 0) {
					data = this._prependCustomLinks(data);
				}
				this.posts = data;
				if (!data || data.length === 0) {
					this.searchStatus = 'none_found';
				} else if (this.FineTunePosts.isLastPage) {
					this.searchStatus = 'no_more_posts';
				} else {
					this.searchStatus = 'loaded';
					this._checkForWhitespace();
				}
			});
			if (this.enableFavoritesSearch === true) {
				this.FineTunePosts.fetchFavorites(search, {}).then(data => {
					this.favoritesPosts = data;
				});
			}
		}
	}

	_checkForWhitespace() {
		if (!this.scrollHandler) {
			return;
		}
		this.whitespaceCheckCount = this.whitespaceCheckCount || 0;
		setTimeout(() => {
			let pos = this.ScrollManager.getPosition(window);
			if (pos.scrollTop === 0 && pos.ratioBottom <= 1 && this.whitespaceCheckCount++ < 4) {
				// we have a large screen or small posts
				// we still need more posts to fill up the page
				// bail after 4 times in case browser position calculations are weird (see PLA-1761)
				this.scrollHandler(pos);
			}
		}, 250);
	}

	loadCheckboxData() {
		this.search.currentHubId = this.Identity.currentClient().id;

		this.FineTunePosts.getCriteriaData(this.search).then(items => {
			// items is an object with properties categories, tags, users, domains, classifications
			_.extend(this, items);

			if (this.taxonomies && this.taxonomies.length) {
				this.taxonomies.forEach(taxonomy => {
					if (!this.search.taxonomies[taxonomy.id]) {
						this.search.taxonomies[taxonomy.id] = {
							options: [],
							matches: 'any',
						};
					}
				});
			}

			this.$timeout(() => {});
		});
		this.checkboxDataLoaded = true;
	}

	loadCheckboxDataIfHubs() {
		if (!this.hubs || this.hubs.length === 0) {
			return;
		}
		this.FineTunePosts.hubs = this.hubs;
		this.loadCheckboxData();
	}

	handleCollapseToggle() {
		this.loadCheckboxDataIfOpen();
	}

	handleInfiniteScrollChange() {
		if (this.scrollHandler && !(this.infiniteScroll > 0)) {
			this.ScrollManager.unregister(window, this.scrollHandler);
		} else if (this.infiniteScroll > 0 && !this.scrollHandler) {
			this.setupInfiniteScroll();
		}
	}

	loadCheckboxDataIfOpen() {
		if (Object.keys(this.search).length > 0 || !this.collapseWhen) {
			if (!this.checkboxDataLoaded) {
				this.loadCheckboxData();
			}
		}
	}

	runSearch(criteria) {
		_.extend(this.search, criteria.search);
		this.loadPosts();
	}

	saveSearchSettings() {
		localStorage.setItem('Search.term_behavior', this.search.termBehavior);
	}

	hasCriteria() {
		return this.FineTunePosts.hasCriteria(this.search);
	}

	isImmutable(fieldName) {
		if (_.get(this.immutableFields, fieldName)) {
			return true;
		}
		return false;
	}

	filterChangeCallback(appliedFilters) {
		if (
			JSON.stringify(this.search) == JSON.stringify(this._getDefaultSearch()) ||
			!appliedFilters ||
			appliedFilters.length == 0
		) {
			this.filterCount = 0;
		} else {
			this.filterCount++;
		}
		if (this.filtersUpdatedCallback) {
			this.filtersUpdatedCallback(this.filterCount);
		}
	}

	_getClassifications() {
		return this.Api.get('/classifications', null, this._getHeaders()).then(data => {
			this.classifications = this._groupDuplicates(data);
		});
	}

	_groupDuplicates(data) {
		if (!data) {
			return [];
		}
		const indexed = {};
		data.forEach(item => {
			const lowerName = item.name.toLowerCase();
			if (!indexed[lowerName]) {
				indexed[lowerName] = { name: item.name, id: [] };
			}
			indexed[lowerName].id.push(item.id);
		});
		const deduplicated = [];
		_.forOwn(indexed, item => {
			deduplicated.push({
				id: item.id.join(','),
				name: item.name,
			});
		});
		return _.sortBy(deduplicated, item => item.name.toLowerCase());
	}

	_handlePostPin(evt, args) {
		const post = args.post;
		const idx = this.posts.indexOf(post);
		if (idx > 0) {
			// remove post from list and add to beginning of list
			this.posts.splice(idx, 1);
			this.posts.unshift(post);
		}
	}

	_handlePostUnpin() {
		// reload posts because the pinned post may drop off
		this.runSearch({});
	}

	isBlacklistColumn(col) {
		if (!Array.isArray(this.blacklistColumns)) {
			return false;
		}
		return this.blacklistColumns.indexOf(col) != -1;
	}

	handleShowArchiveFiltersChange() {
		if (this.showArchiveFilters === false) {
			this._resetArchiveSearch();
		}
	}
	_resetArchiveSearch() {
		this.search.archiveAction = undefined;
		this.search.archiveDatePreset = undefined;
		this.tempArchiveDatePreset = '';
		this.tempArchiveAction = '';
	}
}
